import { ArrayInput, minValue, NumberInput, required, SimpleFormIterator, TextInput } from "react-admin";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { MOBILE_BREAKPOINT } from "utils/constants";

const uniqueSemester = (value, allValues) =>
  allValues?.semesters?.filter(s => Number(s?.semester) === Number(value)).length > 1
    ? "Този семестър вече е добавен!"
    : undefined;

const AcademicReferenceFields = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const sectionSx = isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox;

  return (
    <>
      <Typography
        color="primary"
        sx={{ textAlign: "center", marginTop: "2rem" }}
      >
        Лични данни
      </Typography>
      <Grid
        container
        spacing={2}
        sx={sectionSx}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="firstName"
            label="Име"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="middleName"
            label="Презиме"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="lastName"
            label="Фамилия"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="facultyNumber"
            label="Факултетен номер"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="ean"
            label="EAN"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="identityNumber"
            label="Идентификатор (ЕГН/ЛНЧ)"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <CustomDateInput
            source="birthDate"
            label="Дата на раждане"
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="birthCity"
            label="Място на раждане"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="birthCountry"
            label="Държава на раждане"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="citizenshipCountry"
            label="Гражданство"
            fullWidth
          />
        </Grid>
      </Grid>

      <Typography
        color="primary"
        sx={{ textAlign: "center", marginTop: "2rem" }}
      >
        Академични данни
      </Typography>
      <Grid
        container
        spacing={2}
        sx={sectionSx}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="specialty"
            label="Специалност"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="structuralUnit"
            label="Структурна единица"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="professionalDirection"
            label="Професионално направление"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="studyForm"
            label="Форма на обучение"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="studyType"
            label="Вид на обучение"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <CustomDateInput
            source="admissionDate"
            label="Дата на прием"
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="studyLengthYearsNumbers"
            label="Продължителност на обучение в години (цифри)"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="studyLengthYearsWords"
            label="Продължителност на обучение в години (думи)"
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="studyLengthSemestersNumbers"
            label="Продължителност на обучение в семестри (цифри)"
            fullWidth
          />
        </Grid>
      </Grid>

      <Typography
        color="primary"
        sx={{ textAlign: "center", marginTop: "2rem" }}
      >
        Семестри
      </Typography>
      <Grid
        container
        spacing={2}
        sx={sectionSx}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayInput
            source="semesters"
            label="Семестри"
          >
            <SimpleFormIterator>
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={2}
                >
                  <NumberInput
                    onWheel={event => event.target.blur()}
                    source="semester"
                    label="Семестър"
                    validate={[required(), minValue(1), uniqueSemester]}
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2}
                >
                  <TextInput
                    source="average"
                    label="Среден успех"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={2}
                >
                  <TextInput
                    source="credits"
                    label="Кредити"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <ArrayInput
                    source="rows"
                    label="Дисциплини"
                  >
                    <SimpleFormIterator>
                      <Grid
                        container
                        spacing={2}
                      >
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="disciplineName"
                            label="Дисциплина"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="auditLectureHours"
                            label="Часове лекции"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="auditExerciseHours"
                            label="Часове упражнения"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="outOfAuditHoursNumbers"
                            label="Извънауд. часове (цифри)"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="outOfAuditHoursWords"
                            label="Извънауд. часове (думи)"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="grade"
                            label="Оценка"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="ectsLetter"
                            label="ECTS буква"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="credits"
                            label="Кредити"
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={4}
                        >
                          <TextInput
                            source="teacher"
                            label="Преподавател"
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </SimpleFormIterator>
                  </ArrayInput>
                </Grid>
              </Grid>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </>
  );
};

export default AcademicReferenceFields;
